import { AfterViewChecked, AfterViewInit, Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import * as pdfjsLib from 'pdfjs-dist';
pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';


@Component({
  selector: 'app-visualizador-pdf-dialog',
  templateUrl: './visualizador-pdf-dialog.component.html',
  styleUrl: './visualizador-pdf-dialog.component.scss'
})
export class VisualizadorPdfComponentDialog implements AfterViewChecked{
  @ViewChild('pdfCanvas', { static: false }) pdfCanvas!: ElementRef<HTMLCanvasElement>;
  blob: any
  pdfRenderizado = false
  convertFileBase = false
  tieneBlob: false
  base64: any
  safePdfUrl
  pdfDoc: any;
  currentPage = 1
  zoomLevel = 1

  constructor( 
      @Inject(MAT_DIALOG_DATA) 
      public data, 
      private sanitizer: DomSanitizer,
      public dialogRef: MatDialogRef<VisualizadorPdfComponentDialog>) {

        this.tieneBlob = data.blob
        this.base64 = data.base64
        if(this.tieneBlob){
          
        }else{
          this.safePdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(data.url)
          this.getBase64(data.url)
        }
  }

  ngAfterViewChecked(): void {
    if (this.tieneBlob && !this.pdfRenderizado && this.pdfCanvas) {
      this.pdfRenderizado = true;
      const raw = atob(this.base64);
      const uint8Array = new Uint8Array([...raw].map(c => c.charCodeAt(0)));

      pdfjsLib.getDocument(uint8Array).promise.then(pdf => {
        this.pdfDoc = pdf;
        this.renderPage(this.currentPage);
      });
    }else if(!this.tieneBlob && !this.pdfRenderizado && this.pdfCanvas && this.convertFileBase){
      this.pdfRenderizado = true
      const raw = atob(this.base64.split(',')[1]); 
      const uint8Array = new Uint8Array([...raw].map(c => c.charCodeAt(0)));

      pdfjsLib.getDocument(uint8Array).promise.then(pdf => {
        this.pdfDoc = pdf;
        this.renderPage(this.currentPage);
      });
    }
  }

  base64ToArrayBuffer(base64: string): ArrayBuffer {
    const binaryString = window.atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer;
  }
  
  cerrarDialog() {
    this.dialogRef.close({event: 2});
  }

  renderPage(pageNum: number) {
    this.pdfDoc.getPage(pageNum).then(page => {
      const canvas = this.pdfCanvas.nativeElement;
      const context = canvas.getContext('2d');
      const viewport = page.getViewport({ scale: this.zoomLevel });

      canvas.height = viewport.height;
      canvas.width = viewport.width;

      page.render({
        canvas: canvas,
        canvasContext: context,
        viewport: viewport
      });
    });
  }

  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.renderPage(this.currentPage);
    }
  }

  nextPage() {
    if (this.currentPage < this.pdfDoc.numPages) {
      this.currentPage++;
      this.renderPage(this.currentPage);
    }
  }

  zoomIn() {
    this.zoomLevel += 0.25;
    this.renderPage(this.currentPage);
  }

  zoomOut() {
    if (this.zoomLevel > 0.5) {
      this.zoomLevel -= 0.25;
      this.renderPage(this.currentPage);
    }
  }

  disabledButtons(opc){
    if (!this.pdfDoc) return true

    if(opc === 1){
      return this.currentPage === 1 ? true : false
    }else{
      return this.currentPage === this.pdfDoc.numPages ? true : false
    }
  }

  async getBase64(url){
    this.base64 = await this.pdfUrlToBase64(url)
    this.convertFileBase = true
  }

  download(){

    const base64Data = this.base64.split(',')[1]; // quitar encabezado
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });

    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'archivo.pdf'; // nombre del archivo
    link.click();

    URL.revokeObjectURL(url);
  }

  async pdfUrlToBase64(url: string): Promise<string> {
    const response = await fetch(url);
    const blob = await response.blob();

    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        resolve(reader.result as string); 
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob); 
    });
  }
}
